<template>
  <div class="container">

    <div class="content">
      <h3>{{title}}</h3>
      <div v-html="val">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: '',
      title: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.val = this.$route.query.val,
        this.title = this.$route.query.title
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  position: relative;
  justify-content: center;
  background-color: #ffffff;
  display: flex;
  height: 100%;

  .content {
    padding: 20px 20px 0;
    -webkit-box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.14);
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.14);
    width: 1200px;
    margin-top: 30px;
    margin-bottom: 30px;
    border-radius: 10px;
    height: auto;
    overflow-y: auto;
    border: 0;
    h3 {
      font-weight: 700;
      font-style: normal;
      margin: 30px 0 20px;
      color: #15416e;
      line-height: 1.1;
      text-align: center;
      font-size: 28px;
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>